import React, { useState, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import Loading from "components/Loading";
import moment from "moment";
import { ReactTableDataGrid } from "components/Table";
import { getLeaderboard } from "actions/spyAdvancedActions";
import { getQueryParams } from "components/Function";
import useCallApi from "hook/useCallApi";
import SpyFilter from "../../filter";
import { heightRow, CATEGORIES } from "../../constant";
import useColumnTableTopSold from "../../hooks/useColumnTableTopSold";
import TimeRanger from "./timeRanger";

const limit = 20;

const TabTopSold = ({ typeTab = "top-sold", getLeaderboard }) => {
    const { filter: initialFilter, page: initialPage } = getQueryParams();

    const [filter, setFilter] = useState(initialFilter);
    const [page, setPage] = useState(initialPage);
    const optDate = useMemo(() => {
        const startDateDaily = moment().subtract(1, "day");
        const endDailyDateDaily = moment().subtract(1, "month");
        const endDailyDateWeekly = moment().subtract(12 * 7, "days");
        let currentEnd = moment().clone().startOf("isoWeek").subtract(1, "days");
        const daily = [];
        const weekly = [];
        const currentDaily = startDateDaily.clone();
        const monthly = [];
        const monthsToShow = 12;

        for (let i = 1; i <= monthsToShow; i++) {
            const month = moment().subtract(i, "months").format("YYYY/MM");
            const startOfMonth = moment(month).clone().startOf("month").format("YYYYMMDD");
            const endOfMonth = moment(month).clone().endOf("month").format("YYYYMMDD");
            monthly.push({ label: month, value: `${startOfMonth}-${endOfMonth}` });
        }

        while (currentDaily.isSameOrAfter(endDailyDateDaily)) {
            const data = currentDaily.format("YYYY/MM/DD");
            daily.push({ label: data, value: data.replace(/\//g, "") });
            currentDaily.subtract(1, "day");
        }

        while (currentEnd.isSameOrAfter(endDailyDateWeekly)) {
            const currentStart = currentEnd.clone().subtract(6, "days");

            const label = `${currentStart.format("MM/DD")}-${currentEnd.format("MM/DD")}`;
            const value = `${currentStart.format("YYYYMMDD")}-${currentEnd.format("YYYYMMDD")}`;
            weekly.push({ label: label, value: value });

            currentEnd.subtract(7, "days");
        }

        return { daily, weekly, monthly };
    }, []);

    const params = useMemo(() => {
        if (!filter?.time_range) filter.time_range = optDate?.daily?.[0]?.value;
        if (!filter?.time_type) filter.time_type = "daily";
        filter.type = typeTab;
        return { ...filter, page, per_page: limit };
    }, [filter, page, optDate, typeTab]);
    const { data, loading } = useCallApi(getLeaderboard, params);

    const columns = useColumnTableTopSold(heightRow, filter?.time_type);

    useEffect(() => {
        const cleanedFilter = Object.fromEntries(Object.entries(filter).filter(([_, value]) => value));
        const params = new URLSearchParams({ ...cleanedFilter, page });
        window.history.replaceState({}, "", `${window.location.pathname}?${params.toString()}`);
        return () => {};
    }, [filter, page]);

    const onTableChanged = ({ page }) => {
        if (page) setPage(page);
    };

    return (
        <div className="card mb-5 mb-xl-10">
            <Loading isLoading={loading} />
            <div className="card-body">
                <div className="row mb-10">
                    <div className="col-md-4 d-flex align-items-center">
                        <h1 className="mb-0">
                            {typeTab === "top-sold" ? "Top Selling Products Leaderboard" : "Hot Promoted"}
                        </h1>
                    </div>
                    <div className="col-md-8 position-relative"></div>
                </div>
                <TimeRanger filter={filter} setFilter={setFilter} optDate={optDate} />
                <SpyFilter
                    filter={filter}
                    filterCategory={[
                        {
                            label: "Product Category",
                            key: "product_categories",
                            data: CATEGORIES,
                        },
                    ]}
                    setFilter={(data) => {
                        setFilter(data);
                        setPage(1);
                    }}
                    filterShows={[{ label: "Region", value: "region", defaultValue: "US" }]}
                />
                <div className="mt-10">
                    <ReactTableDataGrid
                        tableName="productSpyAdvancedTopSolds"
                        idProperty="_id"
                        columns={columns}
                        rowData={data?.data || []}
                        pageNumber={page}
                        gridOptions={{
                            rowHeight: heightRow,
                            reactiveCustomComponents: true,
                        }}
                        paginationPageSize={limit}
                        totalSize={data?.meta?.total || 0}
                        emptyText={"No data!"}
                        isSearchText={false}
                        onTableChanged={onTableChanged}
                    />
                </div>
            </div>
        </div>
    );
};

export default connect(null, { getLeaderboard })(TabTopSold);
